import translations from '../translations/global.json';

// Get current language index (0=English, 1=Spanish, 2=French)
// This could come from a context, localStorage, or other source
export const getCurrentLangIndex = (): number => {
  // Replace with your app's language selection logic
  const storedLang = localStorage.getItem('preferredLanguage');
  if (storedLang === 'es') return 1;
  if (storedLang === 'fr') return 2;
  return 0; // Default to English
};

// Access nested properties by path like "general.total"
export const getTranslationByPath = (path: string, langIndex?: number): string => {
  const index = langIndex !== undefined ? langIndex : getCurrentLangIndex();
  
  const parts = path.split('.');
  let current: any = translations;
  
  // Navigate through the path
  for (const part of parts) {
    if (current[part] === undefined) {
      return path; // Return key if translation not found
    }
    current = current[part];
  }
  
  // Handle array of translations or direct value
  if (Array.isArray(current)) {
    return current[index] || current[0] || path;
  }
  
  return String(current);
};

// Shorter alias
export const t = getTranslationByPath; 